import React from 'react';
import { useTranslation } from "react-i18next";
import Testimonial from "../Testimonial/Testimonial";
import './TestimonialsPage.css';
import Sems from '../../../assets/testimonials/Sems.jpg';
import Elkthesis from '../../../assets/testimonials/elkthesis.jpg';
import Unknown from '../../../assets/testimonials/Screenshot 2024-12-11 at 20.14.57.jpg';



function TestimonialsPage() {
    const { t } = useTranslation();
    const testimonials = [
        {
            photo: Sems,
            quote: t('The construction company in which we have complete confidence. With respect, know-how and innovative solutions, for the last 10 years the company and partners of Mr. Abougabal have reconstructed the premises of SEMS S.A. with passion, consistency and understanding of our needs.'),
        },
        {
            photo: Elkthesis,
            quote: t('Mr. Abougabal and his company have always been by our side, ready to find the best technical solutions, solving complex problems and implementing innovative ideas with the use of perfect materials, contributing to a genuine construction and aesthetic result.'),
        },
        {
            photo: Unknown,
            quote: t('The expertise combined with the aesthetics of Mr. Abougabal and his specialized crews, make him the first choice for any small or large construction project. With innovative ideas, experience and understanding, he offers a range of special services that are hard to find anymore.'),
        },
    ];


    return (
        <div className={"testimonials-page"}>
            <h1>{t("Testimonials")}</h1>
            <div className="testimonial-grid-container">
                {testimonials.map((t, index) => (
                    <Testimonial
                        key={index}
                        name={t.name}
                        role={t.role}
                        photo={t.photo}
                        quote={t.quote}
                    />
                ))}
            </div>
        </div>
    );
}

export default TestimonialsPage;
